export default function () {
  const IMAGE_SIZE_LIMIT = 15 * 1024 * 1024; // 15MB
  const imgFileExtensions = ["jpg", "jpeg", "png", "gif", "webp", "svg", "bmp", "tiff"];
  const bonusReceiptFileExtensions = [...imgFileExtensions, "pdf"];
  const wordFileExtensions = ["docx", "doc"];
  const excelFileExtensions = ["xlsx", "xls", "csv"];
  const pdfFileExtensions = ["pdf"];

  function isImage (extension: string): boolean {
    return imgFileExtensions.includes(extension.toLowerCase().replace(".", ""));
  }

  /**
   * Format bytes as human-readable text.
   *
   * @param bytes Number of bytes.
   * @param si True to use metric (SI) units, aka powers of 1000. False to use
   *           binary (IEC), aka powers of 1024.
   * @param dp Number of decimal places to display.
   *
   * @return Formatted string.
   */
  function humanFileSize (bytes: number, si = false, dp = 1) {
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
      return bytes + " B";
    }

    const units = si
      ? ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
      : ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    let u = -1;
    const r = 10 ** dp;

    do {
      bytes /= thresh;
      ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

    return bytes.toFixed(dp) + " " + units[u];
  }

  function extensionWithoutDot (fileName: string): string {
    return fileName.split(".").pop()!;
  }

  return { IMAGE_SIZE_LIMIT, imgFileExtensions, bonusReceiptFileExtensions, wordFileExtensions, excelFileExtensions, pdfFileExtensions, isImage, humanFileSize, extensionWithoutDot };
}
